import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import axios from "axios";
import { Form, Modal, Nav } from "react-bootstrap";
import "../App.css";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { acceptReport, rejectReport } from "../services/reactapis";
import beauty from '../assets/beauty.jpeg';
import Motivate from '../assets/Motivate.jpg';
import Quotes from '../assets/Quotes.jpg';
import { Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { ApiUrl } from '../Constants/Weburl';
import CustomTable from "../components/CustomTable";
import CustomButton from "../components/CustomButton";
import CustomSwitch from "../components/Customswitch";
import CustomPagination from '../components/Custompagination'
import CustomContainer from "../components/Customsettingscontain";
import CustomInput from '../components/Custominput';
import Layout from "../components/Layout";
import useExpandableRows from "../components/useExpandableRows";
import useHiddenColumns from "../components/useHiddenFields";

const getImageUrl = (ApiUrl, img) => {
  if (!img) return "";
  if (img.startsWith("http")) return img;
  return `${ApiUrl}${img.replace("\\", "/")}`;
};

const ReportersCell = ({ r, size = 40 }) => {
  const reporters = r.reporters?.length
    ? r.reporters
    : r.reportedUser
      ? [r.reportedUser]
      : [];

  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0, width: 240 });
  const btnRef = useRef(null);
  const menuRef = useRef(null);

  const toggle = () => {
    if (!open && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPos({
        top: rect.bottom + 4,
        left: rect.left,
        width: Math.max(rect.width, 240),
      });
    }
    setOpen((o) => !o);
  };

  useEffect(() => {
    if (!open) return;

    const onClickOutside = (e) => {
      if (
        menuRef.current?.contains(e.target) ||
        btnRef.current?.contains(e.target)
      )
        return;
      setOpen(false);
    };

    const onScrollOrResize = (e) => {
      // dropdown ulla scroll panna close aagaadhu
      if (e?.target && menuRef.current?.contains(e.target)) return;
      setOpen(false);
    };

    document.addEventListener("mousedown", onClickOutside);
    window.addEventListener("scroll", onScrollOrResize, true);
    window.addEventListener("resize", onScrollOrResize);

    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      window.removeEventListener("scroll", onScrollOrResize, true);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, [open]);

  if (reporters.length === 0) return <span>-----</span>;

  const first = reporters[0];

  // 1 reporter na dropdown illa, normal chip
  if (reporters.length === 1) {
    return (
      <div className="chip">
        <img
          src={getImageUrl(ApiUrl, first.avatar)}
          alt=""
          style={{ width: size, height: size, borderRadius: "50%" }}
        />
        <div>
          <h5 style={{ margin: 0 }}>{first.username}</h5>
          <p style={{ margin: 0 }}>{first.name}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <button
        type="button"
        ref={btnRef}
        onClick={toggle}
        className="chip"
        style={{
          border: "none",
          cursor: "pointer",
          width: "100%",
          textAlign: "left",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <img
          src={getImageUrl(ApiUrl, first.avatar)}
          alt=""
          style={{ width: size, height: size, borderRadius: "50%" }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <h5 style={{ margin: 0 }}>{first.username}</h5>
          <p style={{ margin: 0 }}>+{reporters.length - 1} more</p>
        </div>
        <span style={{ fontSize: 12 }}>{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div
          ref={menuRef}
          style={{
            position: "fixed",
            top: pos.top,
            left: pos.left,
            width: pos.width,
            maxHeight: 240,
            overflowY: "auto",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            zIndex: 1050,
            padding: 6,
          }}
        >
          <div
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: "#6b7280",
              padding: "4px 8px",
            }}
          >
            Reported by {reporters.length} users
          </div>

          {reporters.map((u) => (
            <div
              key={u.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "6px 8px",
                borderRadius: 8,
              }}
            >
              <img
                src={getImageUrl(ApiUrl, u.avatar)}
                alt=""
                style={{ width: 32, height: 32, borderRadius: "50%" }}
              />
              <div>
                <h5 style={{ margin: 0, fontSize: 14 }}>{u.username}</h5>
                <p style={{ margin: 0, fontSize: 12, color: "#6b7280" }}>{u.name}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

// "Reported 2 times" badge
const ReportCountBadge = ({ count }) =>
  count > 1 ? (
    <span
      style={{
        display: "inline-block",
        marginTop: 4,
        padding: "3.6px 3.6px 3.6px 3.6px",
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
        background: "#fee2e2",
        color: "#b91c1c",
        textAlign: 'center'
      }}
    >
      Reported {count} times
    </span>
  ) : null;

const ACTION_LABELS = {
  warning: { text: "Warning", className: "status rejected" },
  post_hidden: { text: "Post Hidden", className: "status post" },
  post_removed: { text: "Post Removed", className: "status post" },
  temp_block_24h: { text: "Blocked 24h", className: "status temporarily" },
  temp_block_7d: { text: "Blocked 7 days", className: "status temporarily" },
  permanent_block: { text: "Permanently Blocked", className: "status block" },
  user_blocked: { text: "Blocked", className: "status block" },
};

const ReportStatus = ({ r }) => {
  if (r.status === "rejected") {
    return <span className="status rejected">Rejected</span>;
  }
  const label = ACTION_LABELS[r.actionTaken];
  return label ? <span className={label.className}>{label.text}</span> : null;
};


const DATE_FORMATS = {
  short:   { day: "2-digit", month: "short", year: "numeric" },                 
  long:    { weekday: "long", day: "numeric", month: "long", year: "numeric" },    
  weekday: { weekday: "long" },                                                  
  month:   { month: "long", year: "numeric" },                                    
};

const formatDate = (date, fmt = "short") =>
  new Date(date).toLocaleDateString("en-IN", DATE_FORMATS[fmt] || DATE_FORMATS.short);

const formatTime = (date) =>
  new Date(date).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

export default function Reports() {
  const [activeTab, setActiveTab] = useState("posts");
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState(10);
  const [type, setType] = useState("post");
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [viewPost, setViewPost] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  //expandDescription
  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  //dataformat
  const [dateFormat, setDateFormat] = useState("short");

  const [detailsList, setDetailsList] = useState(null);

  const adminToken = localStorage.getItem("adminToken");

  const { toggleExpand, isExpanded } = useExpandableRows();

  const postHeaders = [
    { label: "Post", key: "Post", style: { width: "5%" } },
    // { label: "Post User", key: "Postuser", style: { width: "22%" } },
    { label: "Post User", key: "Postuser", style: { width: "22%" }, className: "pt-postuser-col", field: "postuser" },
    { label: "Details", key: "Postdetails", className: "col-hide-4", style: { width: "13%" }, field: "details" },
    { label: "Reported By", key: "Postreport", className: "col-hide-3", style: { width: "25%" }, field: "reportedby" },
    { label: "Date", key: "Postdate", className: "col-hide-2", style: { width: "2%" }, field: "date" },
    { label: "Action", key: "Postaction", className: "col-hide-1", style: { width: "0%" }, field: "action" },
  ];

  const userHeaders = [
    { label: "User", key: "User", style: { width: "10%" } },
    { label: "Details", key: "Details", style: { width: "10%" } },
    { label: "Reported By", key: "ReportedBy", className: "col-hide-3", style: { width: "10%" }, field: "reportedby" },
    { label: "Date", key: "Date", className: "col-hide-2", style: { width: "5%" }, field: "date" },
    { label: "Action", key: "Action", className: "col-hide-1", style: { width: "0%" }, field: "action" },
  ];


  const hiddenFields = useHiddenColumns(
    ".rr1-table",
    activeTab === "posts" ? postHeaders : userHeaders
  );


  const fetchReports = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${ApiUrl}api/getreport`, {
        params: { type },
      });

      console.log("API RESPONSEssss:", res.data);
      setReports(res.data.reports || []);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }, [type]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, entries]);

  const searchLower = useMemo(() => search.toLowerCase(), [search]);

  const filteredReports = useMemo(() => {
    return reports.filter((r) => {
      const name1 =
        r.post?.user?.username ||
        r.postOwner?.username ||
        r.reportedUser?.username ||
        "";
      const reason = r.ReportReason?.title || "";
      return (
        name1.toLowerCase().includes(searchLower) ||
        reason.toLowerCase().includes(searchLower)
      );
    });
  }, [reports, searchLower]);

  const totalPages = useMemo(
    () => Math.ceil(filteredReports.length / entries),
    [filteredReports.length, entries]
  );

  const indexOfLast = currentPage * entries;
  const indexOfFirst = indexOfLast - entries;
  const displayedReports = useMemo(
    () => filteredReports.slice(indexOfFirst, indexOfLast),
    [filteredReports, indexOfFirst, indexOfLast]
  );

  const handleViewContent = useCallback((post) => {
    setViewPost(post);
    setIsViewModalOpen(true);
  }, []);

  // acceptreport api
  const handleAccept = useCallback(async (id) => {
    try {
      await acceptReport(id);
      fetchReports();
    } catch (err) {
      console.log(err.response?.data);
      alert(err.response?.data?.message || "Failed to accept report");
    }
  }, [fetchReports]);

  const handleReject = useCallback(async (id) => {
    try {
      await rejectReport(id);
      fetchReports();
    } catch (err) {
      console.log(err.response?.data);
      alert(err.response?.data?.message || "Failed to reject report");
    }
  }, [fetchReports]);



  const renderDescription = (description, id) => {
    const text = description || "-----";
    const isExpanded = expandedDescriptions[id];

    if (text.length <= 12) {
      return text;
    }

    return (
      <>
        {isExpanded ? text : text.slice(0, 12)}

        <span
          onClick={() =>
            setExpandedDescriptions((prev) => ({
              ...prev,
              [id]: !prev[id],
            }))
          }
          style={{
            color: "#007bff",
            cursor: "pointer",
            marginLeft: "3px",
          }}
        >
          {isExpanded ? " Show less" : "..."}
        </span>
      </>
    );
  };


  const renderDetailsCell = (r) => {
    const list = r.details || [];
    const count = list.length || 1;
    const first = list[0];
    const reason = first?.reason || r.ReportReason?.title || "Report";
    const desc = first?.description || r.description;

    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, minWidth: 130 }}>
        <span style={{
          background: "#eef2ff", color: "#3730a3", fontSize: 12, fontWeight: 600,
          padding: "3px 10px", borderRadius: 12, maxWidth: 160,
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
        }} title={reason}>
          {reason}
        </span>

        {/* {desc && (
          <p title={desc} style={{
            margin: 0, fontSize: 12, color: "#6b7280", maxWidth: 160,
            overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
          }}>
            {desc}
          </p>
        )} */}

        <button
          type="button"
          onClick={() => setDetailsList(list)}
          style={{
            background: count > 1 ? "#fee2e2" : "#f3f4f6",
            color: count > 1 ? "#b91c1c" : "#374151",
            border: "none", borderRadius: 12, padding: "4px 12px",
            fontSize: 12, fontWeight: 600, cursor: "pointer",
          }}
        >
          {count > 1 ? `${count} reports • View` : "View details"}
        </button>
      </div>
    );
  };


  return (
    <div className="layout">
      <Layout>

        <CustomContainer className="rr-wrapperhashtag" fluid="false">
          {/* <div className="topbar"> */}
          {/* <h3>REPORTS</h3> */}
          {/* </div> */}

          <div className="rr-card">
            {/* ------------------------ TABS ----------------------------- */}
            <div className="users-tabs-row">
              <div className="activetab">
                <CustomButton
                  className={activeTab === "posts" ? "tab active" : "tab"}
                  onClick={() => {
                    setActiveTab("posts");
                    setType("post");
                  }}
                >
                  Posts
                </CustomButton>

                <CustomButton
                  className={activeTab === "users" ? "tab active" : "tab"}
                  onClick={() => {
                    setActiveTab("users");
                    setType("user");
                  }}
                >
                  Users
                </CustomButton>
              </div>
              {/* </div> */}

              {/* ---------------- SEARCH + SHOW ENTRIES ---------------- */}
              <div className="users-controls">
                <div className="rr-left">
                  <span>Show</span>

                  <select
                    className="rr-select"
                    value={entries}
                    onChange={(e) => setEntries(Number(e.target.value))}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                  </select>

                  <span>entries</span>
                </div>

                <div className="rr-right">
                  <span>Search: </span>
                  <CustomInput
                    className="rr-select"
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder=""
                  />
                </div>
              </div>
            </div>

            {/* ------------------------ TABLE --------------------------- */}
            <CustomTable
              headers={activeTab === "posts" ? postHeaders : userHeaders}
              className="rr1-table table"
            >
              {loading ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : displayedReports.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    No reports found
                  </td>
                </tr>
              ) : (
                displayedReports.map((r) => {
                  const files = r.post?.files ? JSON.parse(r.post.files) : [];
                  const firstFile = files[0];

                  const mediaUrl = firstFile
                    ? `${ApiUrl}${firstFile.uri.replace(/\\/g, "/")}`
                    : null;

                  const isVideo = firstFile?.type?.includes("video");
                  const isImage = firstFile?.type?.includes("image");

                  return (
                    <React.Fragment key={r.id}>
                      <tr
                        className="rr-actionshastag"
                      >
                        {/* ------------------ POSTS TAB ROW -------------------- */}
                        {activeTab === "posts" && (
                          <>
                            <td className="col-profile rr-actions1" style={{ alignItems: 'center' }}>
                              {hiddenFields.length > 0 && (
                                <button
                                  type="button"
                                  className={`row-expand-toggle ${isExpanded(r.id) ? "is-open" : ""
                                    }`}
                                  onClick={() => toggleExpand(r.id)}
                                  aria-label="Show more details"
                                >
                                  {isExpanded(r.id) ? "−" : "+"}
                                </button>
                              )}
                              <CustomButton
                                className="view-btn"
                                onClick={() => handleViewContent(r.post)}
                              >
                                <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                              </CustomButton>
                            </td>

                            <td className="Postusertable pt-postuser-col">
                              <div className="chip">
                                <img
                                  src={getImageUrl(ApiUrl, r.post?.user?.avatar)}
                                  alt=""
                                  style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                  }}
                                />
                                <div>
                                  <h5>{r.post?.user?.username}</h5>
                                  <p>{r.post?.user?.name}</p>
                                </div>
                              </div>
                            </td>

                            <td className="reasontable col-hide-4">
                              {/* <h5 className="reason-title">{r.ReportReason?.title}</h5> */}
                              {renderDetailsCell(r)}
                              {/* <ReportCountBadge count={r.reportCount} /> */}
                            </td>

                            {/* <td className="cellreport col-hide-3">
                              <div className="chip">
                                <img
                                  src={getImageUrl(ApiUrl, r?.reportedUser?.avatar)}
                                  alt=""
                                  style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                  }}
                                />
                                <div>
                                  <h5>{r?.reportedUser?.username}</h5>
                                  <p>{r?.reportedUser?.name}</p>
                                </div>
                              </div>
                            </td> */}

                            <td className="cellreport col-hide-3">
                              <ReportersCell r={r} />
                            </td>

                            <td className="celldate col-hide-2">
                              {/* {new Date(r.createdAt).toLocaleDateString("en-IN")} */}
                              {formatDate(r.createdAt, dateFormat)}
                            </td>

                            {/* <td className="Postusertable col-hide-1">
                              {r.status === 'pending' && (
                                <>
                                  <CustomButton
                                    className="accept-btn"
                                    onClick={() => handleAccept(r.id)}
                                  >
                                    Accept
                                  </CustomButton>

                                  <CustomButton
                                    className="reject-btn"
                                    onClick={() => handleReject(r.id)}
                                  >
                                    Reject
                                  </CustomButton>
                                </>
                              )}

                              {r.status === 'rejected' && (
                                <span className="status rejected">Rejected</span>
                              )}

                              {r.actionTaken === "warning" && (
                                <span className="status rejected">Warning</span>
                              )}

                              {r.actionTaken === "post_hidden" && (
                                <span className="status post">PostRemoved</span>
                              )}

                              {r.actionTaken === "temp_block_24h" && (
                                <span className="status temporarily">Temporarily Blocked</span>
                              )}

                              {r.actionTaken === "user_blocked" && (
                                <span className="block">Blocked</span>
                              )}

                            </td> */}

                            <td className="Postusertable col-hide-1">
                              {r.status === 'pending' && (
                                <>
                                  <CustomButton
                                    className="accept-btn"
                                    onClick={() => handleAccept(r.id)}
                                  >
                                    Accept
                                  </CustomButton>

                                  <CustomButton
                                    className="reject-btn"
                                    onClick={() => handleReject(r.id)}
                                  >
                                    Reject
                                  </CustomButton>
                                </>
                              )}

                              <ReportStatus r={r} />
                            </td>

                          </>
                        )}

                        {/* ------------------ USERS TAB ROW -------------------- */}
                        {activeTab === "users" && (
                          <>
                            <td className="Postusertable">
                              {hiddenFields.length > 0 && (
                                <button
                                  type="button"
                                  className={`row-expand-toggle ${isExpanded(r.id) ? "is-open" : ""}`}
                                  onClick={() => toggleExpand(r.id)}
                                  aria-label="Show more details"
                                >
                                  {isExpanded(r.id) ? "−" : "+"}
                                </button>
                              )}
                              <div className="chip">
                                <img
                                  src={getImageUrl(ApiUrl, r.postOwner?.avatar)}
                                  alt=""
                                  style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                  }}
                                />
                                <div>
                                  <h5>{r.postOwner?.username}</h5>
                                  <p>{r.postOwner?.name}</p>
                                </div>
                              </div>
                            </td>

                            <td className="reasontable">
                              <h5 className="reason-title">{r.ReportReason?.title}</h5>
                              <p className="reason-text">{renderDetailsCell(r)}</p>
                              <ReportCountBadge count={r.reportCount} />
                            </td>

                            {/* <td className="Postusertable">
                              <div className="chip">
                                <img
                                  src={getImageUrl(ApiUrl, r.reportedUser?.avatar)}
                                  alt=""
                                  style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                  }}
                                />
                                <div>
                                  <h5>{r.reportedUser?.username}</h5>
                                  <p>{r.reportedUser?.name}</p>
                                </div>
                              </div>
                            </td> */}

                            <td className="Postusertable">
                              <ReportersCell r={r} />
                            </td>

                            <td className="celldate">
                              {/* {new Date(r.createdAt).toLocaleDateString("en-IN")} */}
                              {formatDate(r.createdAt, dateFormat)}
                            </td>

                            <td className="Postusertable">
                              {r.status === 'pending' && (
                                <>
                                  <CustomButton
                                    className="accept-btn"
                                    onClick={() => handleAccept(r.id)}
                                  >
                                    Accept Report
                                  </CustomButton>

                                  <CustomButton
                                    className="reject-btn"
                                    onClick={() => handleReject(r.id)}
                                  >
                                    Reject Report
                                  </CustomButton>
                                </>
                              )}

                              <ReportStatus r={r} />

                              {/* {r.status === 'rejected' && (
                                <span className="status rejected">Rejected</span>
                              )}

                              {r.actionTaken === "warning" && (
                                <span className="status rejected">Warning</span>
                              )}

                              {r.actionTaken === "user_blocked" && (
                                <span className="status block">Blocked</span>
                              )} */}
                            </td>
                          </>
                        )}
                      </tr>



                      {isExpanded(r.id) && hiddenFields.length > 0 && (
                        <tr className="row-expand-details">
                          <td colSpan={6}>
                            <div className="expand-details">
                              {hiddenFields.map(({ field, label }) => (
                                <div className="expand-item" key={field}>
                                  <span className="expand-label">{label}</span>
                                  {field === "postuser" && (
                                    <div className="chip">
                                      <img
                                        src={getImageUrl(ApiUrl, r.post?.user?.avatar)}
                                        alt=""
                                        style={{ width: 32, height: 32, borderRadius: "50%" }}
                                      />
                                      <div>
                                        <h5 style={{ margin: 0 }}>{r.post?.user?.username}</h5>
                                        <p style={{ margin: 0 }}>{r.post?.user?.name}</p>
                                      </div>
                                    </div>
                                  )}

                                  {/* {field === "details" && (
                                    <div>
                                      <h5 className="reason-title" style={{ margin: 0 }}>{r.ReportReason?.title}</h5>
                                      <p className="reason-text" style={{ margin: 0 }}>{r.description || "-----"}</p>
                                      <ReportCountBadge count={r.reportCount} />
                                    </div>
                                  )} */}

                                  {field === "details" && <div>{renderDetailsCell(r)}</div>}

                                  {/* {field === "reportedby" && (
                                    <div className="chip">
                                      <img
                                        src={getImageUrl(ApiUrl, r?.reportedUser?.avatar)}
                                        alt=""
                                        style={{ width: 32, height: 32, borderRadius: "50%" }}
                                      />
                                      <div>
                                        <h5 style={{ margin: 0 }}>{r?.reportedUser?.username}</h5>
                                        <p style={{ margin: 0 }}>{r?.reportedUser?.name}</p>
                                      </div>
                                    </div>
                                  )} */}

                                  {field === "reportedby" && <ReportersCell r={r} size={32} />}

                                  {field === "date" && (
                                    <span className="expand-value">
                                      {/* {new Date(r.createdAt).toLocaleDateString("en-IN")} */}
                                      {formatDate(r.createdAt, dateFormat)}
                                    </span>
                                  )}
                                  {/* 
                                  {field === "action" && (
                                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                      {r.status === "pending" && (
                                        <>
                                          <CustomButton className="accept-btn" onClick={() => handleAccept(r.id)}>
                                            {activeTab === "posts" ? "Accept" : "Accept Report"}
                                          </CustomButton>
                                          <CustomButton className="reject-btn" onClick={() => handleReject(r.id)}>
                                            {activeTab === "posts" ? "Reject" : "Reject Report"}
                                          </CustomButton>
                                        </>
                                      )}
                                      {r.status === "rejected" && <span className="status rejected">Rejected</span>}
                                      {r.actionTaken === "warning" && <span className="status rejected">Warning</span>}
                                      {activeTab === "posts" && r.actionTaken === "post_hidden" && (
                                        <span className="status post">PostRemoved</span>
                                      )}
                                      {activeTab === "posts" && r.actionTaken === "temp_block_24h" && (
                                        <span className="status temporarily">Temporarily Blocked</span>
                                      )}
                                      {r.actionTaken === "user_blocked" && (
                                        <span className={activeTab === "posts" ? "block" : "status block"}>Blocked</span>
                                      )}
                                    </div>
                                  )} */}
                                  {field === "action" && (
                                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                      {r.status === "pending" && (
                                        <>
                                          <CustomButton className="accept-btn" onClick={() => handleAccept(r.id)}>
                                            {activeTab === "posts" ? "Accept" : "Accept Report"}
                                          </CustomButton>
                                          <CustomButton className="reject-btn" onClick={() => handleReject(r.id)}>
                                            {activeTab === "posts" ? "Reject" : "Reject Report"}
                                          </CustomButton>
                                        </>
                                      )}
                                      <ReportStatus r={r} />
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      )}


                    </React.Fragment>
                  )
                })
              )}
            </CustomTable>

            {/* ----------------------- PAGINATION ------------------------ */}
            <div className="pagination-container">
              {/* <span>
                Showing {indexOfFirst + 1} to{" "}
                {Math.min(indexOfLast, filteredReports.length)} of{" "}
                {filteredReports.length} entries
              </span> */}
              <span>
                Showing 1 to {reports.length} of {reports.length} entries
              </span>

              <CustomPagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
                className="rr-pagination"
                pageClassName="rr-page"
                activeClassName="active-page"
                ellipsisClassName="rr-page"
              />
            </div>


            {/* ------------------------ VIEW MODAL --------------------------- */}
            <Modal
              show={isViewModalOpen && viewPost !== null}
              onHide={() => setIsViewModalOpen(false)}
              centered
              dialogClassName="modal-box"
            >
              {viewPost && (
                <>
                  <Modal.Header style={{ borderBottom: "none", position: "relative" }}>
                    <CustomButton
                      className="close-btn"
                      onClick={() => setIsViewModalOpen(false)}
                    >
                      ✕
                    </CustomButton>
                    <Modal.Title style={{ marginTop: "-5px" }}>View Content</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {viewPost.text && <p>{viewPost.text}</p>}

                    <h3>
                      {viewPost.hashtags
                        ? JSON.parse(viewPost.hashtags).map((tag) => `#${tag}`).join(" ")
                        : ""}
                    </h3>

                    {viewPost.mentions && (
                      <p>
                        {JSON.parse(viewPost.mentions).map((m) => `@${m}`).join(" ")}
                      </p>
                    )}

                    {/* ---- POST CONTENT (SWIPER) ---- */}
                    <div className="content-preview" style={{ width: "100%" }}>
                      {(() => {
                        if (!viewPost.files) return <p>No media</p>;

                        const files = JSON.parse(viewPost.files);

                        return (
                          <Swiper spaceBetween={10} slidesPerView={1} modules={[Pagination, Scrollbar, A11y]}
                            navigation
                            pagination={{ clickable: true }}
                            scrollbar={{ draggable: true }}
                            onSwiper={(swiper) => console.log(swiper)}
                            onSlideChange={() => console.log('slide change')}

                          >
                            {files.map((file, index) => {
                              const fileUrl = `${ApiUrl}${file.uri.replace(
                                /\\/g,
                                "/"
                              )}`;

                              return (
                                <SwiperSlide key={index}>
                                  {file.type?.includes("image") ? (
                                    <img
                                      src={fileUrl}
                                      alt=""
                                      style={{
                                        width: "100%",
                                        height: "400px",
                                        objectFit: "cover",
                                        borderRadius: 10,
                                      }}
                                    />
                                  ) : file.type?.includes("video") ? (
                                    <video
                                      src={fileUrl}
                                      controls
                                      style={{
                                        width: "100%",
                                        height: "400px",
                                        objectFit: "cover",
                                        borderRadius: 10,
                                      }}
                                    />
                                  ) : null}
                                </SwiperSlide>
                              );
                            })}
                          </Swiper>
                        );
                      })()}
                    </div>
                  </Modal.Body>
                </>
              )}
            </Modal>


            <Modal
              show={detailsList !== null}
              onHide={() => setDetailsList(null)}
              centered
              dialogClassName="modal-box"
            >
              <Modal.Header closeButton>
                <Modal.Title>All Reports ({detailsList?.length || 0})</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: 450, overflowY: "auto" }}>
                {detailsList?.map((d, i) => (
                  <div
                    key={d.id}
                    style={{
                      padding: "10px 0",
                      borderBottom: i < detailsList.length - 1 ? "1px solid #eee" : "none",
                    }}
                  >
                    <div className="chip" style={{ marginBottom: 6 }}>
                      <img
                        src={getImageUrl(ApiUrl, d.reporter?.avatar)}
                        alt=""
                        style={{ width: 32, height: 32, borderRadius: "50%" }}
                      />
                      <div>
                        <h5 style={{ margin: 0 }}>{d.reporter?.username || "Unknown"}</h5>
                        <p style={{ margin: 0, fontSize: 12 }}>
                          {/* {new Date(d.createdAt).toLocaleString("en-IN")} */}
                          {formatDate(d.createdAt, dateFormat)} • {formatTime(d.createdAt)}
                        </p>
                      </div>
                    </div>
                    <div><strong>Reason:</strong> {d.reason || "-----"}</div>
                    <div><strong>Description:</strong> {d.description || "-----"}</div>
                  </div>
                ))}
              </Modal.Body>
            </Modal>

          </div>
        </CustomContainer>
      </Layout>

    </div>
  );
}
